'use client'
import * as React from 'react';

var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWalletWithSunglasses = function SvgWalletWithSunglasses(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4779FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.002 5.333a5.333 5.333 0 0 1 5.333 5.334h-32c-3.094 0-5.88 1.317-7.83 3.422.901-4.98 5.258-8.756 10.497-8.756h24ZM58.667 26.667C58.667 20.776 53.891 16 48 16H16c-5.89 0-10.666 4.776-10.666 10.667V48c0 5.891 4.775 10.667 10.666 10.667h32c5.891 0 10.667-4.776 10.667-10.667V26.667Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.928 37.787a7.431 7.431 0 1 0 14.862 0 7.431 7.431 0 0 0-14.862 0Zm-22.88 0a7.43 7.43 0 1 0 14.861 0 7.43 7.43 0 0 0-14.862 0Zm30.311-9.037a9.035 9.035 0 0 1 7.566 4.103h1.522a.803.803 0 0 1 0 1.606h-.688a8.98 8.98 0 0 1 .638 3.328c0 4.984-4.054 9.038-9.038 9.038-4.983 0-9.037-4.054-9.037-9.038 0-1.114.204-2.18.575-3.166a3.718 3.718 0 0 0-3.276-1.926 3.748 3.748 0 0 0-2.903 1.383 8.983 8.983 0 0 1 .798 3.71c0 4.983-4.054 9.037-9.038 9.037-4.983 0-9.037-4.054-9.037-9.038a8.98 8.98 0 0 1 .637-3.328h-.525a.803.803 0 1 1 0-1.606h1.36a9.035 9.035 0 0 1 7.565-4.103 9.03 9.03 0 0 1 7.404 3.864 5.354 5.354 0 0 1 3.74-1.526c1.628 0 3.102.72 4.09 1.893a9.036 9.036 0 0 1 7.647-4.231Z",
    fill: "var(--dynamic-base-2)",
    stroke: "var(--dynamic-base-2)",
    strokeWidth: 0.5
  })));
};

export { SvgWalletWithSunglasses as ReactComponent };
